import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=bf867834&"
import script from "./Reset.vue?vue&type=script&lang=js&"
export * from "./Reset.vue?vue&type=script&lang=js&"
import style0 from "./Reset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf867834')) {
      api.createRecord('bf867834', component.options)
    } else {
      api.reload('bf867834', component.options)
    }
    module.hot.accept("./Reset.vue?vue&type=template&id=bf867834&", function () {
      api.rerender('bf867834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/user/Reset.vue"
export default component.exports